// Core packages
import { formatDate } from '@angular/common';
// Third party packages
import { TranslateService } from '@ngx-translate/core';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { FileService } from 'src/app/shared/services/file.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/config.service";
import * as i3 from "../../shared/services/file.service";
import * as i4 from "../../shared/services/helper.service";
import * as i5 from "@ngx-translate/core";
/** Mime type of the generated "Nota informativa" document */
export var INFORMATIVE_NOTE_PDF_MIME = 'application/pdf';
/**
 * "Nota informativa" service: admin companies that have the condo-owner privacy
 * access key (company.subscription.informativeNote). Independent additional service,
 * compatible with both "privacy" and "privacySag".
 *
 * @since 3.0.0
 */
var InformativeNoteService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function InformativeNoteService(apiService, configService, fileService, helperService, translateService) {
        this.apiService = apiService;
        this.configService = configService;
        this.fileService = fileService;
        this.helperService = helperService;
        this.translateService = translateService;
    }
    /**
     * Generate the "Nota informativa" PDF (4 QR codes with clickable links) of the given company.
     * The front-end host is sent so the back-end can build the public QR links;
     * the back-end only accepts the platform's own front-ends.
     *
     * @since 3.0.0
     *
     * @param companyId Company Id
     */
    InformativeNoteService.prototype.generateDocument = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('POST', "companies/" + companyId + "/informative-note/document", { frontendOrigin: this.configService.frontEndHost }, { responseType: 'blob' }, undefined, undefined, 'v2').pipe(catchError(function (err) { return _this.helperService.parseErrorBlob(err); }));
    };
    /**
     * Generate the "Nota informativa" document as a ready-to-save file
     * (typed blob + localized, timestamped file name)
     *
     * @since 3.0.0
     *
     * @param companyId Company Id
     */
    InformativeNoteService.prototype.generateDocumentFile = function (companyId) {
        var date = formatDate(new Date(), 'yyyyMMddHHmmss', 'en-EN');
        var fileName = this.translateService.instant('companies.detail.privacyDocsCard.informativeNote.exportFileName') + "-" + date + ".pdf";
        return this.generateDocument(companyId).pipe(map(function (blob) { return ({ blob: new Blob([blob], { type: INFORMATIVE_NOTE_PDF_MIME }), fileName: fileName }); }));
    };
    /**
     * Upload a generated document through the standard files endpoint, so it can be
     * pre-attached to SendEmailDialogComponent ("attachments" file-uploader value).
     *
     * @since 3.0.0
     *
     * @param file Generated document
     * @param fileName File name shown to the recipients
     * @returns Uploaded files, in the same shape returned to the file-uploader field
     */
    InformativeNoteService.prototype.uploadForEmail = function (file, fileName) {
        var formData = new FormData();
        formData.append('file[]', file, fileName);
        return this.fileService.uploadImportingFiles(formData).pipe(map(function (res) {
            if (!res || !res.status || !Array.isArray(res.files) || !res.files.length) {
                throw new Error((res && res.message) || 'Upload failed');
            }
            return res.files;
        }));
    };
    /**
     * Get the paginated list of "Nota informativa" companies
     *
     * @since 3.0.0
     */
    InformativeNoteService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        return this.apiService.apiCall('GET', 'companies/informative-note', this.buildParams(start, limit, sort, sortVersus, search), undefined, undefined, undefined, 'v2');
    };
    /**
     * Get the Excel export of the "Nota informativa" companies (same filters as the list)
     *
     * @since 3.0.0
     */
    InformativeNoteService.prototype.getExport = function (sort, sortVersus, search) {
        var _this = this;
        return this.apiService.apiCall('GET', 'companies/informative-note/export', this.buildParams(undefined, undefined, sort, sortVersus, search), { responseType: 'blob' }, undefined, undefined, 'v2').pipe(catchError(function (err) { return _this.helperService.parseErrorBlob(err); }));
    };
    /**
     * Build query params, flattening search as search[key]=value
     */
    InformativeNoteService.prototype.buildParams = function (start, limit, sort, sortVersus, search) {
        var params = {};
        if (typeof start === 'number') {
            params.start = start;
        }
        if (typeof limit === 'number') {
            params.limit = limit;
        }
        if (sort) {
            params.sort = sort;
        }
        if (sortVersus) {
            params.sortVersus = sortVersus;
        }
        if (search) {
            Object.keys(search).forEach(function (key) {
                if (search[key] !== null && search[key] !== undefined && search[key] !== '') {
                    params["search[" + key + "]"] = search[key];
                }
            });
        }
        return params;
    };
    InformativeNoteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InformativeNoteService_Factory() { return new InformativeNoteService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.FileService), i0.ɵɵinject(i4.HelperService), i0.ɵɵinject(i5.TranslateService)); }, token: InformativeNoteService, providedIn: "root" });
    return InformativeNoteService;
}());
export { InformativeNoteService };
